import { render, staticRenderFns } from "./topMenu.vue?vue&type=template&id=b8b2257e&scoped=true&"
import script from "./topMenu.vue?vue&type=script&lang=js&"
export * from "./topMenu.vue?vue&type=script&lang=js&"
import style0 from "./topMenu.vue?vue&type=style&index=0&id=b8b2257e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b2257e",
  null
  
)

export default component.exports